﻿import "./video.scss";

(function ($) {
    //Decalare in Global Namespace	
    window.M2 = window.M2 || {};
    window.M2.Video = {};

    const videoPlayers = [];

    const playerTheme = {
        gm: {
            color: "243541"
        },
        gsa: {
            color: "a53d70"
        },
        school: {
            color: "243541"
        },
        wfc: {
            color: "243541"
        },
        default: {
            color: "333333"
        }
    }

    const acceptedFileTypes = [
        "video/mp4",
        "video/mov",
        "video/quicktime",
        "video/mwv",
        "video/avi"
    ];

    let uploadFileSizeLimit = 10000000000;

    function getProcessingUrl(updateVideoUrl, data) {
        return $.ajax({
            url: updateVideoUrl,
            type: 'POST',
            data: data
        });
    }

    function processVideo(videoUploadUrl, video_file, gaugeId) {
        return $.ajax({
            url: videoUploadUrl,
            type: 'PATCH',
            processData: false,
            headers: {
                'Tus-Resumable': '1.0.0',
                'Upload-Offset': 0,
                'Content-Type': 'application/offset+octet-stream',
                'Accept': 'application/vnd.vimeo.*+json;version=3.4'
            },
            data: video_file,
            xhr: function () {
                var xhr = new window.XMLHttpRequest();
                xhr.upload.addEventListener("progress", function (evt) {
                    if (evt.lengthComputable) {
                        setUploaderStatusGauge(gaugeId, evt.loaded);
                    }
                }, false);
                return xhr;
            }
        });
    }

    function postMediaId(postMediaIdUrl, data) {
        return $.ajax({
            url: postMediaIdUrl,
            type: 'POST',
            data: data
        });
    }

    function getUploadStatus(videoUploadUrl) {
        return $.ajax({
            url: videoUploadUrl,
            type: 'HEAD',
            headers: {
                'Tus-Resumable': '1.0.0',
                'Accept': 'application/vnd.vimeo.*+json;version=3.4'
            }
        });
    }

    function disableUpload($uploadBtn, $videoFile) {
        if ($uploadBtn) $uploadBtn.addClass('disabled');
        if ($videoFile) $videoFile.addClass('hidden');
    }

    function enableUpload($uploadBtn, $videoFile) {
        if ($uploadBtn) $uploadBtn.removeClass('disabled');
        if ($videoFile) $videoFile.removeClass('hidden').val('');
    }

    function createUploaderStatusGauge(id, val, total) {
        const $uploaderGauge = $('<div/>', {
            'id': id,
            'class': 'file-upload-status'
        });
        $uploaderGauge.progressbar({ value: val, max: total });
        return $uploaderGauge;
    }

    function setUploaderStatusGauge(gaugeId, currentValue) {
        $("#" + gaugeId).progressbar('value', currentValue);
    }

    function setVideoPlayers() {
        $('.video-player').each(function () {
            const $player = $(this);
            const playerId = $player.attr('id');
            const mediaId = $player.data('media-id');
            const theme = $player.data('player-theme');
            const autoplay = $player.data('player-autoplay') ? $player.data('player-autoplay') : false;
            const playerControls = $player.data('player-controls') ? $player.data('player-controls') : true;
            const noSeek = $player.data('no-seek') ? $player.data('no-seek') : false;

            if (mediaId) M2.Video.setPlayer({
                "playerId": playerId,
                "mediaId": mediaId,
                "theme": theme,
                "autoplay": autoplay,
                "playerControls": playerControls,
                "noSeek": noSeek
            });                
        });

        $('.video-player-btn').each(function () {
            $(this).on('click', function (e) {
                e.preventDefault();
                const $btn = $(this);
                const playerId = $btn.data('player-id');
                const playClass = 'play';
                const playLabel = $btn.data('play-label');
                const pauseClass = 'pause';
                const pauseLabel = $btn.data('pause-label');
                const isPlay = $btn.hasClass(playClass) ? true : false;

                if (isPlay) {
                    $btn.removeClass(playClass).addClass(pauseClass);
                    $btn.html(pauseLabel);
                    M2.Video.play(playerId);
                } else {
                    $btn.removeClass(pauseClass).addClass(playClass);
                    $btn.html(playLabel);
                    M2.Video.pause(playerId);
                }
            });

            
        });
    }

    function checkUploadStatus(videoUploadUrl) {
        const deferred = $.Deferred();
        const uploadInterval = setInterval(
            function () {
                getUploadStatus(videoUploadUrl).done(function (message, text, jqXHR) {
                    const uploadOffset = parseInt(jqXHR.getResponseHeader('Upload-Offset'));
                    const uploadLength = parseInt(jqXHR.getResponseHeader('Upload-Length'));
                    if (uploadOffset === uploadLength) {
                        deferred.resolve();
                        clearInterval(uploadInterval);
                    }
                });
            }, 100);
        return deferred.promise();
    }

    const errorMessages = {
        "invalidFileType": "Please specify a valid video file (.mp4, .mov, .wmv, and .avi)",
        "exceedsFileSizeLimit": "Video file is too large, maximum file size is 10GB"
    }

    M2.Video = {
        init: function () {
            setVideoPlayers();
        },
        getErrorMessage: function (type) {
            return errorMessages[type];
        },
        getProcessingStatus: function (processingStatusUrl) {
            return $.ajax({
                url: processingStatusUrl,
                type: 'GET'
            });
        },
        isValidFileSize: function (fileSize) {
            const response = {
                "status": fileSize <= uploadFileSizeLimit,
                "error": errorMessages["exceedsFileSizeLimit"]
            }
            return response;
        },
        isValidFileType: function (fileType) {
            const response = {
                "status": acceptedFileTypes.includes(fileType),
                "error": errorMessages["invalidFileType"]
            }
            return response;
        },
        upload: function (playerId, $uploadBtn, $videoFile, updateVideoUrl, callback, params) {
            params = params || {};
            const file_data = $videoFile.prop("files")[0];
            const fileSize = file_data.size;
            const gaugeId = "gauge-" + playerId;
            params.fileSize = fileSize;

            // Disable the upload buttons and set the loading gauge
            disableUpload($uploadBtn, $videoFile);
            const $uploaderGauge = createUploaderStatusGauge(gaugeId, 0, fileSize);
            $uploaderGauge.insertAfter($videoFile);
        
            getProcessingUrl(updateVideoUrl, params).done(function (data) {
                const videoUploadUrl = data.url;
                let media_id_url = data.media_id_url;

                // Once we have the URL, start processing the video
                processVideo(videoUploadUrl, file_data, gaugeId).done(function () {
                    // Check to see that the full video is with the video processor 
                    checkUploadStatus(videoUploadUrl).then(function () {
                        // Post the Media Id
                        postMediaId(media_id_url, params);
                        //Remove the Gauge
                        $uploaderGauge.remove();
                        // Enable the upload buttons
                        enableUpload($uploadBtn, $videoFile);
                        // Inititate any callbacks
                        if (typeof callback === 'function' && callback()) {
                            callback();
                        }
                    });
                }).fail(function (jqXHR, textStatus, errorThrow) {
                    if (typeof callback === 'function' && callback()) {
                        callback(errorThrow);
                    }
                });
            });
        },
        updatePlayer: function (playerId, mediaId) {
            const videoPlayer = this.getPlayer(playerId);
            videoPlayer.loadVideo(mediaId).then(function (id) {
                return true;
            }).catch(function (error) {
                return false;
            });
        },
        setPlayer: function (props) {
            const playerId = props.playerId;
            const mediaId = props.mediaId;
            const theme = props.theme;
            const autoplay = props.autoplay;
            const playerControls = props.playerControls;
            const noSeek = props.noSeek;
            const hasPlayer = this.getPlayer(playerId) ? true : false;
            const playerColor = theme ? playerTheme[theme].color : playerTheme['default'].color;

            if (hasPlayer) {
                this.updatePlayer(playerId, mediaId);
                return;
            }
            
            const options = {
                id: mediaId,
                url: 'https://player.vimeo.com/video/' + mediaId,
                byline: false,
                portrait: false,
                title: false,
                color: playerColor,
                autoplay: autoplay,
                controls: playerControls
            };
            try {
                videoPlayers[playerId] = new Vimeo.Player(playerId, options);
                let timeWatched = 0;
                videoPlayers[playerId].on("timeupdate", function (data) {
                    if (data.seconds - 1 < timeWatched && data.seconds > timeWatched) {
                        timeWatched = data.seconds;
                    }
                });
                videoPlayers[playerId].on("seeked", function (data) {
                    if (timeWatched < data.seconds) {
                        videoPlayers[playerId].setCurrentTime(timeWatched);
                    }
                });

                videoPlayers[playerId].on('loaded', function () {
                    if (window.frameElement) {
                        try {
                            const iframe = parent.document.getElementById(window.frameElement.id);
                            iframe.height = iframe.contentWindow.document.body.scrollHeight + "px";
                        } catch (e) {
                            console.log(e);
                        }
                    }
                });
            } catch (err) {
                console.log(err);
                videoPlayers[playerId] = null;
            }
        },
        getPlayer: function (playerId) {
            return videoPlayers[playerId];
        },
        play: function (playerId) {
            if (videoPlayers[playerId]) videoPlayers[playerId].play();
        },
        pause: function (playerId) {
            if (videoPlayers[playerId]) videoPlayers[playerId].pause();
        },
        getAllPlayers: function () {
            return videoPlayers;
        },
        destroyPlayer: function (playerId) {
            if (videoPlayers[playerId]) videoPlayers[playerId].destroy();
        }
    };
})(jQuery);

$(function () {
    M2.Video.init();
});